// ============================================================
// OVERDUE PAYMENTS WIDGET (Dashboard)
// ============================================================

import { AlertCircle } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../services/api';

export function OverduePaymentsWidget() {
  const [overdueCount, setOverdueCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOverdueCount = async () => {
      try {
        const response = await api.get('/admin/payment-plans', {
          params: { status: 'IN_PROGRESS' },
        });

        if (response.data?.success && response.data?.data) {
          const plans = response.data.data;
          const count = plans.reduce((acc: number, plan: any) => {
            const overdueInstallments = plan.installments?.filter((inst: any) => inst.status === 'OVERDUE').length || 0;
            return acc + overdueInstallments;
          }, 0);
          setOverdueCount(count);
        }
      } catch (error) {
        console.error('[OverduePaymentsWidget] Erreur chargement:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchOverdueCount();
  }, []);

  if (loading || overdueCount === 0) {
    return null;
  }

  return (
    <div
      onClick={() => navigate('/payment-plans')}
      className="bg-gradient-to-br from-red-50 to-red-100 border border-red-200 rounded-xl p-6 cursor-pointer hover:shadow-md transition-all"
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <AlertCircle className="w-5 h-5 text-red-600" />
            <h3 className="font-semibold text-slate-900">Paiements en retard</h3>
          </div>
          <div className="text-3xl font-bold text-red-600 mb-1">{overdueCount}</div>
          <p className="text-sm text-slate-600">Échéances dépassées de +48h</p>
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-red-200">
        <span className="text-xs text-red-700 font-medium">Cliquer pour voir les détails →</span>
      </div>
    </div>
  );
}
